import { SrPartialPackingTypeMap } from '@plato/data/starrocks/types';
import { z } from 'zod';

export const partialPackagingTypeSchema = z.enum(SrPartialPackingTypeMap).catch('UNKNOWN');

export const productVariantDtoSchema = z.object({
    article_group_id: z.string().nullable(),
    article_group_name: z.string().nullable(),
    package_unit: z.string().nullable(),
    partial_packing_type: partialPackagingTypeSchema.nullable(),
    product_variant_id: z.string(),
    product_variant_name: z.string(),
    quantity_unit_sales: z.string().nullable(),
    sales_units_per_package_unit: z.number().nullable(),
});

export type ProductVariantDTO = z.infer<typeof productVariantDtoSchema>;

export enum ProductVariantSortBy {
    PRODUCT_VARIANT_ID = 'product_variant_id',
    PRODUCT_NAME = 'product_variant_name',
}
